import { Card, CardContent } from "@sylviq/ui-react-web/components/ui/card";
import type { ReactNode } from "react";

export interface EmptyStateProps {
  icon?: ReactNode;
  /** What is empty, e.g. "No invoices yet". */
  title: string;
  /** One sentence on why it is empty and what fills it. */
  reason: string;
  /**
   * The single next step. One on purpose — someone seeing this screen for
   * the first time should have exactly one thing to do, not a menu.
   */
  action?: ReactNode;
}

/** Placeholder for an empty list or table. */
export function EmptyState({ icon, title, reason, action }: EmptyStateProps) {
  return (
    <Card>
      <CardContent className="flex flex-col items-center gap-2 px-6 py-10 text-center">
        {icon ? (
          <span aria-hidden="true" className="text-[var(--muted-foreground)]">
            {icon}
          </span>
        ) : null}
        <h2 className="text-base font-semibold tracking-tight">{title}</h2>
        <p className="max-w-md text-sm text-[var(--muted-foreground)]">
          {reason}
        </p>
        {action ? <span className="mt-2">{action}</span> : null}
      </CardContent>
    </Card>
  );
}
